module.exports = __webpack_public_path__ + "static/media/standard.88c4ea01.png";